// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { prop } from 'ramda';

// aliased
import people from 'data/people';
import { formatRange } from 'utils/date';
import TagList from 'components/TagList';
import Link from 'components/Link';
import Icon from 'components/Icon';
import Carousel from 'components/Carousel';
import Image from 'components/Image';
import Section from 'components/Section';
import config from 'config';

// local
import styles from './ProjectDetails.pcss';
import LinkList from './LinkList';

const getHostname = (str) => str.replace(/^https?:\/\//, '').match(/[^/]*/)[0];
const getPrettyHostname = (url) => getHostname(url).replace(/^www\./, '');

export default class ProjectDetails extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
    project: PropTypes.shape({
      contributors: PropTypes.arrayOf(PropTypes.string),
      images: PropTypes.arrayOf(PropTypes.string),
      description: PropTypes.arrayOf(PropTypes.node),
      dates: PropTypes.arrayOf(PropTypes.string),
      website: PropTypes.string,
      links: PropTypes.arrayOf(PropTypes.string),
    }),
  }
  static defaultProps = {
    
  }

  componentWillMount = () => config.browser && window.addEventListener('keydown', this.handleKeyDown)
  componentWillUnmount = () => config.browser && window.removeEventListener('keydown', this.handleKeyDown)
  
  handleKeyDown = (event) => {
    if (event.code === 'ArrowRight') return this.carousel.next();
    if (event.code === 'ArrowLeft') return this.carousel.prev();
  }
  
  saveCarouselRef = (ref) => (this.carousel = ref)
  
  get headline() {
    const { company, project } = this.props;
    const { dates } = project;
    return (
      <div className={ styles.headline }>
        { company && <h1 className={ styles.company }>{ company.name }</h1> }
        <h2 className={ styles.name }>{ this.name }</h2>
        {
          prop('length', dates)
            ? <div className={ styles.date }>{ formatRange(dates) }</div>
            : null
        }
      </div>
    );
  }
  
  get name() {
    const { project } = this.props;
    const { website, name } = project;
    if (!website) return name;
    return (
      <Link to={ website }>
        { name }
        <Icon className={ styles.linkIcon } type={ 'link' } />
      </Link>
    );
  }
  
  get description() {
    const { project } = this.props;
    const { description } = project;
    if (!description || !description.length) return null;
    return (
      <div className={ styles.description }>
        {
          description.map((line, i) => (
            <p key={ i }>{ line }</p>
          ))
        }
      </div>
    );
  }
  
  get contributors() {
    const { project } = this.props;
    const { contributors } = project;
    if (!contributors || !contributors.length) return null;
    
    const links = contributors.sort().map((personSlug) => {
      const { website: url, name: title } = people.find(({ slug }) => slug === personSlug);
      return { url, title };
    });
    
    return (
      <LinkList
        hidden={ !contributors || !contributors.length }
        links={ links } />
    );
  }
  
  get links() {
    const { project } = this.props;
    const { links } = project;
    
    const linkObjects = links.map((url) => {
      if (typeof url === 'object') return url;
      if (typeof url === 'string') return  { title: getPrettyHostname(url), url };
    });
    
    return (
      <LinkList
        hidden={ !links || !links.length }
        links={ linkObjects } />
    );
  }
  
  render() {
    const { className, project } = this.props;
    
    const classes = classnames(className, styles.projectDetails);
    
    return (
      <div className={ classes } onKeyDown={ this.handleKeyDown }>
        <Carousel ref={ this.saveCarouselRef } className={ styles.carousel }>
          {
            project.images.map((image, i) => (
              <Image
                key={ image }
                className={ styles.heroImage }
                src={ image }
                alt={ `project image ${ i }` } />
            ))
          }
        </Carousel>
        <div className={ styles.copy }>
          <Section className={ styles.section }>
            { this.headline }
          </Section>
          <Section className={ styles.section }>
            { this.description }
          </Section>
          <Section className={ styles.section }>
            <TagList tags={ project.tech } />
          </Section>
          <Section
            className={ styles.section }
            title={ 'Contributors' }
            hidden={ (!project.contributors || !project.contributors.length) }
          >
            { this.contributors }
          </Section>
          <Section
            className={ styles.section }
            title={ 'Links' }
            hidden={ (!project.links || !project.links.length) }
          >
            { this.links }
          </Section>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectDetails/index.jsx